/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import SelectWithPagination from 'components/shared/dropdown-with-pagination/SelectWithPagination';
import { Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Form, Tooltip } from 'react-bootstrap';

import ConfigurableTable from 'components/shared/table/ConfigurableTable';

import {
  resetSitePerformanceFilters,
  setActiveSectionTab,
  setAllInsightView,
  setExcelColumnRestiction,
  setFilterInit,
  setInsightType,
  setIsAccountableProduct,
  setProducts,
  setSelectedCustomer,
  setSelectedInsightView,
  setSeletedView,
  setSiteExpression,
  setSitePerformanceTimePeriod,
} from 'store/customer/customerViewSlice';
import {
  SITE_PERFOMANCE_COLUMNS,
  SITE_PERFORMANCE_FILTER_NAME,
  CHECKBOXCLASS,
  TABLE_NAME_SITE_PERFORMANCE,
  CONTRACT_SEGMENT,
  FLAG,
  PAGINATION,
  INSIGHT_TYPE,
  SORT_BY,
  MODULE_NAME,
  NUMBER_ZERO,
  QUERY_KEY,
  ACCOUNT_TYPE,
  COMPONENT_MAPPING,
} from 'constants/constants';
import {
  exportData,
  getSitePerformanceData,
} from 'store/customer/customer-view-actions';
import {
  excludeColumnFromExcel,
  getCustomerExpr,
  getRestrictedColumn,
  isArray,
} from 'utils/utils';
import { SITE_PERF_APP_ID } from 'constants/constants';
import { setSitePerformanceSquad } from 'store/customer/customerViewSlice';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import GNESingleSelect from 'components/shared/dropdown/GNESingleSelect';
import OverlayTrigger from 'components/shared/tooltip/Tooltip';
import OverlayIcon from 'components/shared/overlay-icon/OverlayIcon';

const SitePerformance = (props) => {
  const isAccountableProduct = useSelector(
    (state) => state?.CustomerView?.sitePerformanceFilters?.IsAccountableProduct
  );
  const selectedSquad = useSelector(
    (state) =>
      state?.CustomerView?.sitePerformanceFilters?.SiteSquad?.selectedValue
  );
  const selectedEcosystem = useSelector(
    (state) =>
      state?.CustomerView?.sitePerformanceFilters?.Ecosystem?.selectedValue
  );
  const selectedContractSegment = useSelector(
    (state) =>
      state?.CustomerView?.sitePerformanceFilters?.contract_segment_Filter
        ?.selectedValue
  );
  // eslint-disable-next-line no-unused-vars
  const [showMarketShare, setShowMarketShare] = useState(true);

  const timeSpanOptions = useSelector(
    (state) => state?.CustomerView?.timespans
  );

  const isExporting = useSelector((state) => state?.CustomerView?.exportSite);

  const dispatch = useDispatch();
  const columnRestriction = useSelector(
    (state) => state?.CustomerView?.columnsRestiction
  );

  useEffect(() => {
    let excelColumnName = excludeColumnFromExcel(columnRestriction);
    dispatch(setExcelColumnRestiction(excelColumnName));
  }, [columnRestriction]);

  const selectedCustomer = useSelector(
    (state) => state?.CustomerView?.selectedCustomer
  );
  const selectedProducts = useSelector(
    (state) =>
      state?.CustomerView?.sitePerformanceFilters?.Product?.selectedValue
  );
  const filteredColumns = showMarketShare
    ? SITE_PERFOMANCE_COLUMNS
    : SITE_PERFOMANCE_COLUMNS.filter((column) => column.key !== 'marketShare');

  const selectedSites = useSelector(
    (state) =>
      state?.CustomerView?.sitePerformanceFilters
        ?.Site_Performance_SiteName_Address?.selectedValue
  );
  const sitePerformanceFilters = useSelector(
    (state) => state?.CustomerView?.sitePerformanceFilters
  );
  const productOptions = useSelector(
    (state) => state?.CustomerView?.sitePerformanceFilters?.Product
  );
  const ecosystemOptions = useSelector(
    (state) => state?.CustomerView?.sitePerformanceFilters?.Ecosystem
  );
  const squadOptions = useSelector(
    (state) => state?.CustomerView?.sitePerformanceFilters?.Squad
  );
  const siteOptions = useSelector(
    (state) => state?.CustomerView?.sitePerformanceFilters?.Site
  );
  const contractsegmentOptions = useSelector(
    (state) =>
      state?.CustomerView?.sitePerformanceFilters?.contract_segment_Filter
  );
  const selectedTimePeriod = useSelector(
    (state) => state?.CustomerView?.sitePerformanceFilters?.TimePeriod
  );

  const activeSectionTab = useSelector(
    (state) => state?.CustomerView?.activeSectionTab
  );

  const navigation = useNavigate();

  const siteExpressionExport = useSelector(
    (state) => state?.CustomerView?.siteExpression
  );
  let siteFilterExpression;

  useEffect(() => {
    if (!Array.isArray(selectedCustomer)) buildExpression();
  }, [
    selectedCustomer,
    selectedProducts,
    selectedSites,
    selectedTimePeriod,
    isAccountableProduct,
    selectedSquad,
    selectedEcosystem,
    selectedContractSegment,
    selectedCustomer?.value,
  ]);

  const [timeSpan, setTimeSpan] = useState('');

  useEffect(() => {
    setTimeSpan(
      timeSpanOptions
        ?.filter(
          (item) =>
            item.TimePeriod === selectedTimePeriod?.selectedValue?.label &&
            item.Module === MODULE_NAME.SitePerformance
        )
        [NUMBER_ZERO]?.Value?.replaceAll("'", ' ')
    );
  }, [selectedTimePeriod, timeSpanOptions]);

  const initailState = {
    values: [],
    offset: 0,
    totalSize: 0,
  };

  const [sitePerformanceData, setSitePerformanceData] = useState(initailState);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(PAGINATION.defaultPageSize);
  const [sortBy, setSortBy] = useState({
    column: 'grossSales',
    order: SORT_BY.descend,
  });

  const [menuIsOpen, setMenuIsOpen] = useState({
    Ecosystem: false,
    Site_Performance_SiteName_Address: false,
    SiteSquad: false,
    Product: false,
    contract_segment_Filter: false,
  });

  const pagination = {
    current: pageIndex,
    total: sitePerformanceData?.totalSize,
    pageSize: pageSize,
    pageSizeOptions: PAGINATION.pageSizeOptions,
    showSizeChanger: true,
    disabledPageSizehandler: true,
  };

  const timePeriodOptions = [
    { value: 'R3', label: 'R3M' },
    { value: 'R6', label: 'R6M' },
    { value: 'R12', label: 'R12M' },
    { value: 'YTD', label: 'YTD' },
  ];

  const buildExpression = () => {
    const isAllProd =
      isArray(productOptions) &&
      productOptions?.length === selectedProducts?.length;

    const isAllSite =
      isArray(siteOptions) && siteOptions?.length === selectedSites?.length;

    const isAllSquad =
      isArray(squadOptions) && squadOptions?.length === selectedSquad?.length;

    const isAllEcosystem =
      isArray(ecosystemOptions) &&
      ecosystemOptions?.length === selectedEcosystem?.length;

    const allContractSegment =
      isArray(contractsegmentOptions) &&
      contractsegmentOptions?.length === selectedContractSegment?.length;

    const ecosystem = isAllEcosystem ? 'Ecosystem=' : selectedEcosystem;
    const squad = isAllSquad ? 'Squad=' : selectedSquad;

    const products = isAllProd ? 'Product=' : selectedProducts;

    const sites = isAllSite ? 'Site=' : selectedSites;

    const contractsegment = allContractSegment
      ? 'contract_segment_Filter='
      : selectedContractSegment;

    const accountExp = getCustomerExpr(
      selectedCustomer,
      isArray(selectedCustomer)
    );

    // build product expression
    const productExp = isArray(products)
      ? 'Product={"' + products.map((a) => a.label).join('","') + '"}'
      : '';

    // build business site expression
    const siteExp = isArray(sites)
      ? 'Site_ID={"' + sites.map((a) => a.value).join('","') + '"}'
      : '';
    //build Ecosystem  expression
    const ecosystemExp = isArray(ecosystem)
      ? 'Ecosystem={"' + ecosystem.map((a) => a.label).join('","') + '"}'
      : '';

    const squadExp = isArray(squad)
      ? 'Squad={"' + squad.map((a) => a.label).join('","') + '"}'
      : '';
    const contractsengmentExp = isArray(contractsegment)
      ? 'contract_segment_Filter={"' +
        contractsegment.map((a) => a.label).join('","') +
        '"}'
      : '';
    siteFilterExpression = `${accountExp}`;
    if (productExp !== '')
      siteFilterExpression = siteFilterExpression.concat(`, ${productExp}`);
    if (siteExp !== '')
      siteFilterExpression = siteFilterExpression.concat(`, ${siteExp}`);
    if (ecosystemExp !== '')
      siteFilterExpression = siteFilterExpression.concat(`, ${ecosystemExp}`);
    if (squadExp !== '')
      siteFilterExpression = siteFilterExpression.concat(`, ${squadExp}`);
    if (contractsengmentExp !== '')
      siteFilterExpression = siteFilterExpression.concat(
        `, ${contractsengmentExp}`
      );
    if (isAccountableProduct !== undefined && isAccountableProduct === true)
      siteFilterExpression = siteFilterExpression.concat(
        ', "isAccountableProduct"={"Y"}'
      );
    dispatch(setSiteExpression(siteFilterExpression));
  };

  const { data, isLoading } = useQuery({
    queryKey: [
      QUERY_KEY.SitePerformanceTable,
      selectedCustomer?.value,
      selectedProducts,
      selectedSites,
      selectedTimePeriod?.selectedValue,
      selectedEcosystem,
      selectedSquad,
      selectedContractSegment,
      isAccountableProduct,
      sortBy.column,
      sortBy.order,
      pageIndex,
      pageSize,
    ],
    queryFn: async () => {
      buildExpression();
      // Calculate offset - will be 0 when pageIndex is 1
      const result = await getSitePerformanceData(
        siteFilterExpression,
        0, // will set actual offset and pageSize once pagination done from backend
        selectedTimePeriod?.selectedValue,
        sortBy.column,
        sortBy.order
      );
      return result?.values?.length > 0 ? result : initailState;
    },
    enabled:
      activeSectionTab === COMPONENT_MAPPING.SitePerformance ? true : false,
  });

  useEffect(() => {
    if (data) {
      setSitePerformanceData(data);
    }
  }, [data]);

  const handleClick = (rowData, index) => {
    dispatch(setActiveSectionTab(''));
    const payload = {
      value: rowData?.mdmId,
      label: rowData?.siteName,
      zip: rowData?.zip,
      flag: FLAG.site[0],
    };
    dispatch(setFilterInit());
    dispatch(setSeletedView(ACCOUNT_TYPE.site));
    dispatch(setSelectedCustomer(payload));
    dispatch(setInsightType(INSIGHT_TYPE.GENERAL));
    dispatch(setSelectedInsightView({}));
    dispatch(setAllInsightView([]));
    navigation(`/customerView/list/${rowData?.siteName}`);
  };

  const handleTableChange = (column, order, pagination) => {
    let currentPageSize = pagination.pageSize;

    // Reset page to 1 if page size changed
    if (pageSize !== currentPageSize) {
      setPageIndex(1);
      setPageSize(currentPageSize);
    } else {
      setPageIndex(pagination.current);
    }

    setSortBy({ column, order: SORT_BY[order] });
  };

  const handleAccountProdCheckbox = (e) => {
    dispatch(setIsAccountableProduct(e?.target?.checked));
    dispatch(setProducts({ options: [], selectedValue: [] }));
    dispatch(setSitePerformanceSquad({ options: [], selectedValue: [] }));
  };

  const onMenuOpen = useCallback((filterName, value) => {
    let menuIsOpenLocal = menuIsOpen;
    if (filterName !== '' && value) {
      menuIsOpenLocal = Object.keys(menuIsOpen).reduce((acc, key) => {
        return { ...acc, [key]: filterName === key };
      }, {});
    } else if ((filterName !== '' && !value) || filterName === '') {
      menuIsOpenLocal = Object.keys(menuIsOpen).reduce((acc, key) => {
        return { ...acc, [key]: false };
      }, {});
    }
    setMenuIsOpen({ ...menuIsOpenLocal });
  }, []);
  const downloadData = () => {
    dispatch(
      exportData(
        TABLE_NAME_SITE_PERFORMANCE,
        selectedCustomer?.value,
        siteExpressionExport,
        selectedTimePeriod?.selectedValue,
        '',
        '',
        excludeColumnFromExcel(columnRestriction)
      )
    );
  };
  const exportTooltip = (
    <Tooltip className='gne-tooltip'>Send to Excel</Tooltip>
  );

  const resetFilters = () => {
    dispatch(resetSitePerformanceFilters({ retainTimePeriod: true }));
  };

  const handleFilterChange = (value) => {
    setPageIndex(1);
  };

  const size = { x: 1550, y: 400 };

  return (
    <div id='SitePerformance'>
      <Row>
        <Col
          md={6}
          className='d-flex align-items-center'>
          <p className='title title__bold title__large mb-0'>
            Site Performance
          </p>
        </Col>
        <Col
          className='d-flex justify-content-end align-items-center'
          md={6}>
          <OverlayIcon
            tooltip={'Reset Filters'}
            onClick={resetFilters}
            className={`icon icon__reset-filters`}
          />
          <OverlayTrigger overlay={exportTooltip}>
            <i
              onClick={downloadData}
              className={`icon icon__affiliations_export_excel1 ms-2`}
            />
          </OverlayTrigger>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <p className='title__small pt-0 text text__grey'>{timeSpan}</p>
        </Col>
      </Row>
      <Row>
        <Col md={2}>
          <label className='title__x-small'>Time Period</label>
          <GNESingleSelect
            value={selectedTimePeriod?.selectedValue}
            onChange={(e) => {
              dispatch(
                setSitePerformanceTimePeriod({
                  selectedValue: e,
                })
              );
              setPageIndex(1);
            }}
            options={timePeriodOptions}
            className='single-select'
          />
        </Col>
        <Col md={2}>
          <label className='title__x-small'>Ecosystem</label>
          <SelectWithPagination
            menuIsOpen={menuIsOpen}
            onMenuOpen={onMenuOpen}
            filter={sitePerformanceFilters}
            appid={SITE_PERF_APP_ID}
            fieldName='Ecosystem'
            isMulti={true}
            filterName={SITE_PERFORMANCE_FILTER_NAME}
            cacheUniqs={[selectedCustomer]}
            onChange={handleFilterChange}
          />
        </Col>
        <Col md={2}>
          <label className='title__x-small'>Site</label>
          <SelectWithPagination
            menuIsOpen={menuIsOpen}
            onMenuOpen={onMenuOpen}
            filter={sitePerformanceFilters}
            fieldName='Site_Performance_SiteName_Address'
            appid={SITE_PERF_APP_ID}
            isMulti={true}
            filterName={SITE_PERFORMANCE_FILTER_NAME}
            cacheUniqs={[selectedCustomer]}
            onChange={handleFilterChange}
          />
        </Col>
        <Col md={2}>
          <label className='title__x-small'>Squad</label>
          <SelectWithPagination
            menuIsOpen={menuIsOpen}
            onMenuOpen={onMenuOpen}
            filter={sitePerformanceFilters}
            fieldName='SiteSquad'
            appid={SITE_PERF_APP_ID}
            isMulti={true}
            filterName={SITE_PERFORMANCE_FILTER_NAME}
            cacheUniqs={[
              selectedCustomer,
              isAccountableProduct,
              selectedProducts,
            ]}
            onChange={handleFilterChange}
          />
        </Col>

        <Col md={2}>
          <label className='title__x-small'>Products</label>
          <SelectWithPagination
            menuIsOpen={menuIsOpen}
            onMenuOpen={onMenuOpen}
            filter={sitePerformanceFilters}
            fieldName='Product'
            isMulti={true}
            appid={SITE_PERF_APP_ID}
            filterName={SITE_PERFORMANCE_FILTER_NAME}
            cacheUniqs={[selectedCustomer, isAccountableProduct, selectedSquad]}
            onChange={handleFilterChange}
          />
        </Col>
        {!excludeColumnFromExcel(columnRestriction).includes(
          CONTRACT_SEGMENT
        ) && (
          <Col md={2}>
            <label className='title__x-small'>Contract Segment</label>
            <SelectWithPagination
              menuIsOpen={menuIsOpen}
              onMenuOpen={onMenuOpen}
              filter={sitePerformanceFilters}
              fieldName='contract_segment_Filter'
              isMulti={true}
              appid={SITE_PERF_APP_ID}
              filterName={SITE_PERFORMANCE_FILTER_NAME}
              cacheUniqs={[selectedCustomer, isAccountableProduct]}
              onChange={handleFilterChange}
            />
          </Col>
        )}
        <Col md={3}>
          <label className='title__x-small w-100'></label>

          <span className='title__small'>
            <Form.Check
              inline
              type='checkbox'
              label='Accountable Products'
              checked={isAccountableProduct}
              onChange={handleAccountProdCheckbox}
              className={isAccountableProduct && CHECKBOXCLASS}
            />
          </span>
        </Col>
      </Row>
      &nbsp;
      <Row>
        <Col xs={12}>
          <Spin spinning={isLoading || isExporting}>
            <ConfigurableTable
              rows={sitePerformanceData?.values || []}
              columns={getRestrictedColumn(
                TABLE_NAME_SITE_PERFORMANCE,
                filteredColumns,
                columnRestriction
              ).map((col) => {
                if (col.dataIndex === 'siteName') {
                  return {
                    ...col,
                    render: (text, record) => (
                      <span
                        className='span-link'
                        onClick={() => handleClick(record)}>
                        {text}
                      </span>
                    ),
                  };
                }
                return col;
              })}
              expandRowByClick={false}
              enableColumnSelection={false}
              enableExport={false}
              exportFileName='sitePerformanceDetails'
              tableName={TABLE_NAME_SITE_PERFORMANCE}
              expression={siteFilterExpression}
              isGlobalExport={true}
              pagination={pagination}
              isGlobalSort={true}
              onSort={handleTableChange}
              timePeriod={selectedTimePeriod?.selectedValue}
              dimentions={size}
            />
          </Spin>
        </Col>
      </Row>
    </div>
  );
};

export default SitePerformance;
